/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Illegal_Char_TitleInputs */

const en_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illegal Character Detected`)
};

const fr_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractere illegal detecte`)
};

const de_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiges Zeichen erkannt`)
};

const it_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carattere illegale rilevato`)
};

const ru_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружен недопустимый символ.`)
};

const es_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carácter ilegal detectado`)
};

const zh_cn2_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测到非法字符`)
};

const ja_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正な文字が検出されました`)
};

const hi_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवैध वर्ण का पता चला`)
};

const pt_pt2_embed_captions_illegal_char_title = /** @type {(inputs: Embed_Captions_Illegal_Char_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractere ilegal detectado`)
};

/**
* | output |
* | --- |
* | "Illegal Character Detected" |
*
* @param {Embed_Captions_Illegal_Char_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_illegal_char_title = /** @type {((inputs?: Embed_Captions_Illegal_Char_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Illegal_Char_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_illegal_char_title(inputs)
	if (locale === "de") return de_embed_captions_illegal_char_title(inputs)
	if (locale === "it") return it_embed_captions_illegal_char_title(inputs)
	if (locale === "ru") return ru_embed_captions_illegal_char_title(inputs)
	if (locale === "es") return es_embed_captions_illegal_char_title(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_illegal_char_title(inputs)
	if (locale === "ja") return ja_embed_captions_illegal_char_title(inputs)
	if (locale === "hi") return hi_embed_captions_illegal_char_title(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_illegal_char_title(inputs)
	return en_embed_captions_illegal_char_title(inputs)
});